import { render, staticRenderFns } from "./ConfiguracionView.vue?vue&type=template&id=261ef29b&"
import script from "./ConfiguracionView.vue?vue&type=script&lang=ts&"
export * from "./ConfiguracionView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports